import { createContext, useContext, useState, ReactNode } from 'react';
import { UserCourse } from '../types/userCourse';

interface UserCourseContextType {
  userCourse: UserCourse | null;
  setUserCourse: (userCourse: UserCourse | null) => void;
  currentLessonType: 'video' | 'quiz' | 'game' | null;
  setCurrentLessonType: (type: 'video' | 'quiz' | 'game' | null) => void;
}

// Create context with null default
export const UserCourseContext = createContext<UserCourseContextType>({
  userCourse: null,
  setUserCourse: () => {},
  currentLessonType: null,
  setCurrentLessonType: () => {},
});

// Provider component
export const UserCourseProvider = ({ children }: { children: ReactNode }) => {
  const [userCourse, setUserCourse] = useState<UserCourse | null>(null);
  const [currentLessonType, setCurrentLessonType] = useState<'video' | 'quiz' | 'game' | null>(null);

  return (
    <UserCourseContext.Provider value={{ userCourse, setUserCourse, currentLessonType, setCurrentLessonType }}>
      {children}
    </UserCourseContext.Provider>
  );
};

// Export hook for consuming the context
export const useUserCourseContext = () => {
  return useContext(UserCourseContext);
};
